// unit: filter3
import f from "../../../../funcs";
import Operator from "./Operator";


let InRange = Operator.extend("InRange", {
    literal: ["inRange"],

    validateValue(value) {
        return f.isArrOf(f.isDateDistance, value);
    },

    compile2js(left, right) {
        if ( !f.isArray(right) || !right.length ) {
            return "false";
        }

        let value;
        let start; let end;
        let result = "";

        for (let i = 0, n = right.length; i < n; i++) {
            value = right[ i ];
            start = value && f.clientTime2unixTimestamp(value.start);
            end = value && f.clientTime2unixTimestamp(value.end);

            if ( f.isNaN(start) || f.isNaN(end) ) {
                continue;
            }

            if ( result ) {
                result += " || ";
            }
            result += left + " >= " + start + " && " + left + " <= " + end;
        }

        result += "";

        if ( !result ) {
            result = "true";
        } else {
            result = left + " != null && (" + result + ")";
        }

        return result;
    }
});

export default InRange;
